import { utils as reducerUtils } from 'redux-rest-reducer';
import { ACTIONS } from 'actions/online-plan-courses';
import RestReducer from './reducer';

export default RestReducer(ACTIONS, (state, { type, payload }) => {
  switch (type) {
    case ACTIONS.INVALIDATE_ITEM:
      return reducerUtils.changeItemToStale(state, payload.id);
    case ACTIONS.INVALIDATE_LIST:
      return reducerUtils.changeListToStale(state);
    default:
      return state;
  }
});
